import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import Api from "@/api/API";
import confirm from "@/directives/confirm";
import clipboard from "@/directives/clipboard";
import i18n from "./plugins/i18n";
import { abilitiesPlugin } from "@casl/vue";
import ability from "./plugins/ability";
import VueApexCharts from "vue-apexcharts";
import fullscreen from "@/directives/fullscreen";
import moment from "moment";
import handleUnsaved from "@/directives/handle-unsaved";
import { mask } from "vue-the-mask";

Vue.config.productionTip = false;

Vue.component("apexchart", VueApexCharts);

Vue.prototype.$moment = moment;
Vue.prototype.$API = Api;

Vue.use(VueApexCharts);
Vue.use(abilitiesPlugin, ability);

Vue.directive("confirm", confirm);
Vue.directive("clipboard", clipboard);
Vue.directive("fullscreen", fullscreen);
Vue.directive("handle-unsaved", handleUnsaved);
Vue.directive("mask", mask);

const vue = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

export default vue;
